// extracted by mini-css-extract-plugin
export default {"legends-button":"Ml7XfHiOUdwZhgXFU2Ko","legends-button-icon":"XUtGYocMYWSyH2Hs6z2z","legends-popup":"ZPDEsUffTJoT0Iq1gwEU"};